import { useState } from 'react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/solid'

import ContentFrame from 'components/Frame/ContentFrame'

export default function FrequentlyAskedQuestions({ faqs = [] }) {

    const [expandedIndices, setExpandedIndices] = useState(new Set())

    const ToggleFAQ = (index) => {
        setExpandedIndices(prev => {
            const newSet = new Set(prev)
            if (newSet.has(index)) {
                newSet.delete(index)
            } else {
                newSet.add(index)
            }
            return newSet
        })
    }

    const isExpanded = (index) => expandedIndices.has(index)

    return (
        <ContentFrame className="divide-y divide-gray-300">
            {faqs.map((faq, index) => (
                <div 
                    key={index} 
                    className="w-full"
                >
                    <button 
                        onClick={() => ToggleFAQ(index)}
                        className="p-4 flex w-full items-start justify-between text-left text-gray-900 hover:bg-gray-50 transition-colors"
                    >
                        <p>{faq.question}</p>

                        <span className="ml-6 flex h-7 items-center transition-transform duration-300">
                            {isExpanded(index) ? (
                                <MinusSmallIcon className="h-6 w-6 text-gray-500" aria-hidden="true" />
                            ) : (
                                <PlusSmallIcon className="h-6 w-6 text-gray-500" aria-hidden="true" />
                            )}
                        </span>
                    </button>

                    <div 
                        className={`
                            overflow-hidden transition-all duration-300 ease-in-out 
                            ${isExpanded(index) ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}
                        `}
                    >
                        <div className="pl-4 pb-4 pr-12 space-y-2">
                            {faq.answer.map((answer, answerIndex) => (
                                <p key={answerIndex} className="text-sm leading-6 text-gray-600">{answer}</p>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </ContentFrame>
    )
}